import { IconComponent } from './types';

const TableIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={10}
    viewBox="0 0 10 10"
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      d="M10 6.5H0M10 3.5H0M.5 10V0M5 10V3M9.5 10V0M10 .5H0M10 9.5H0"
    />
  </svg>
);
export default TableIcon;
